
PaymentConfirmation = function(txtChargeTerms) {
	return new Promise(function(resolve, reject) {
		var paymentModal = $('.payment-confirmation').clone().show();
		paymentModal.find('.charge-terms').html(txtChargeTerms);
		Swal.fire({
			title: 'Terms & Conditions',
			html: paymentModal[0],
			width: '70%',
			showCancelButton: false,
			showConfirmButton: false,
			onClose: reject,
		});
		paymentModal.find('.confirm-payment').click(resolve);
		paymentModal.find('.cancel-payment').click(Swal.close);
	});
}